import React, { useMemo, useState } from 'react';
import '../../SkipButton.css';
import CoinIcon from '../../icons/CoinIcon';
import AddCoinsPill from '../../coins/AddCoinsPill';

const GenerationsSkipButton = ({ onSkip, disabled, costCoins, isBuffering, labelOverride }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleClick = async () => {
    // When we're out of coins we still want the embedded "Add Coins" pill to be clickable,
    // so we do NOT rely on the HTML disabled attribute in that case.
    if (disabled || isProcessing || labelOverride === 'Not enough coins') return;
    setIsProcessing(true);
    try {
      await onSkip?.();
    } finally {
      setIsProcessing(false);
    }
  };

  // Keep the button label stable. If coins are low, we still say "Skip"
  // and offer "Buy Coins" separately (below the button).
  const label = isProcessing ? 'Skipping…' : isBuffering ? 'Buffering Skip' : 'Skip';

  const showAddCoins = useMemo(() => labelOverride === 'Not enough coins', [labelOverride]);
  const disableMainAction = disabled || isProcessing || showAddCoins;
  const useNativeDisabled = (disabled || isProcessing) && !showAddCoins;

  return (
    <div className="skip-button-wrap">
      <button
        className={`skip-button ${disableMainAction ? 'disabled' : ''} ${showAddCoins ? 'add-coins-state' : ''}`.trim()}
        type="button"
        onClick={handleClick}
        disabled={useNativeDisabled}
        aria-disabled={disableMainAction}
      >
        <span className="label">{label}</span>
        <span className="cost-indicator">
          {costCoins}
          <CoinIcon />
        </span>

        {showAddCoins && <AddCoinsPill className="cost-indicator add-coins-pill" />}
      </button>
    </div>
  );
};

export default GenerationsSkipButton;

